var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusicInputIcon = function SvgMusicInputIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.6 14a2.12 2.12 0 0 1-1.49-.621 2.09 2.09 0 0 1-.61-1.484c0-1.175.927-2.104 2.1-2.104.463 0 .9.163 1.281.437l.11.082V3.56c0-.41.326-.738.709-.738l7.01-.82h.054c.382-.028.736.3.736.71v7.898c0 .574-.218 1.094-.627 1.476a2.104 2.104 0 0 1-2.962-.02A2.103 2.103 0 0 1 11.4 8.478c.6 0 .745.169 1.1.442V5.259L6 6.102v5.793C6 13.5 4.745 14 3.6 14"
  })));
};
export default SvgMusicInputIcon;